import React, { useState, useEffect, useMemo } from "react";
import Header from "../common/Header";
import Topbar from "../common/Topbar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector, connect } from "react-redux";
import {
  collapseHeader,
  unCollapseHeader,
} from "../redux/actions/fucntionActions";
// import Breadcrumb from "../components/Breadcrumb";

function ProtectedRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatchAction = useDispatch();
  const ftmUserData = localStorage.getItem("ftmUserData");
  const [className, setClassName] = useState("sidebar");
  const [isSidebar, setIsSideBar] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [width, setWidth] = useState("");
  const callback = (state) => state;
  const states = useSelector(callback);

  useEffect(() => {
    // Check if the current path is a share page
    const isSharePage = location.pathname.includes("/share");
    // Redirect to login page if not authenticated and not on the share page
    if (!ftmUserData && !isSharePage) {
      navigate("/login");
    }
  }, [ftmUserData, navigate, location.pathname]);

  useEffect(() => {
    setWidth(window.innerWidth);
  });

  function getSize() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", getSize);
    if (window.innerWidth < 590) {
      setIsSideBar(true);
      setCollapsed(true);
      setClassName("collapsableSidebar");
    } else if (window.innerWidth >= 590 && window.innerWidth < 1090) {
      setIsSideBar(true);
      setCollapsed(true);
      setClassName("collapsableSidebar");
    } else {
      setIsSideBar(true);
      setCollapsed(false);
      setClassName("sidebar");
    }
    return () => {
      window.removeEventListener("resize", getSize);
    };
  }, [window.innerWidth]);

  const userData = useMemo(() => {
    return ftmUserData ? JSON.parse(ftmUserData) : null;
  }, [ftmUserData]);

  const toggleSidebar = () => {
    if (width < 590) {
      setIsSideBar(!isSidebar);
      setCollapsed(!collapsed);
    } else if (width >= 590 && width < 1090) {
      setIsSideBar(true);
      setCollapsed(true);
    } else if (width >= 1091) {
      handleCollapse();
    }
  };

  const handleCollapse = () => {
    setCollapsed(!collapsed);
    if (collapsed) {
      dispatchAction(collapseHeader(true));
    } else {
      dispatchAction(unCollapseHeader(false));
    }
  };

  useEffect(() => {
    if (states?.collapsable?.collapsed == true) {
      setClassName("collapsableSidebar");
    } else if (states?.collapsable?.collapsed == false) {
      setClassName("sidebar");
    }
  }, [states.collapsable.collapsed]);

  const closeSidebar = () => {
    if (window.innerWidth < 590) {
      setIsSideBar(true);
      setCollapsed(true);
    } else if (window.innerWidth >= 590 && window.innerWidth < 1090) {
      setIsSideBar(true);
      setCollapsed(true);
    }
  };

  return (
    <>
      <Topbar
        userType="fleetOwner"
        userData={userData}
        toggleSidebar={toggleSidebar}
      />
      <div className="main-parent-div">
        <Header
          userType="fleetOwner"
          userData={userData}
          isFuel={userData?.isFuel ? userData?.isFuel : false}
          isSidebar={isSidebar}
          setIsSideBar={setIsSideBar}
          setCollapsed={setCollapsed}
          collapsed={collapsed}
          newClasss={className}
          closeSidebar={closeSidebar}
        />
        <div className="main-content">
          {/* <Breadcrumb userType="fleetOwner" /> */}
          <Outlet />
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  collapsed: state.collapsed,
});

const mapDispatchToProps = (dispatch) => ({
  handleCollapse: () => dispatch({ type: "collapsed" }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute);
